// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"938f010f54147d05","4544":"aa7ed8b47a9a70ba","7322":"113ee8ccd7e6c2ca","8074":"05ce65b66b1ff77d"}[chunkId] + ".css";
};